import classNames from "classnames";
import CheckBox from "../../../../../../components/CheckBox";

import { DComponent } from "../../../../../../components/DComponent";
import { Address } from "../../../../../../models/Address";
import { LocalStorage } from "../../../../../../models/LocalStorage";
import AddressForm from "../AddressForm";

export default class AddressInfo extends DComponent {
  constructor({
    parent,
    id,
    type,
    className = "",
    countryList = [],
    phoneOptions = {},
    onDialCode = () => { },
    onChangePhone = () => { },
    onSaveAddress = () => { },
    onCheckSave = () => { },
  } = {}) {
    super(arguments[0], parent, id, {
      class: classNames("AddressInfo", className),
    }, true);
    this.type = type;
    this.className = className;
    this.phoneOptions = phoneOptions;
    /** @type {AddressForm} */
    this.addressForm = undefined;
    /** @type {CheckBox} */
    this.checkSave = undefined;
    this.currentCity = {};
    this.currentDistrict = {};
    this.currentWard = {};
    this.countryList = countryList;
    this.onDialCode = onDialCode;
    this.onChangePhone = onChangePhone;
    this.onSaveAddress = onSaveAddress;
    this.onCheckSave = onCheckSave;
    this.isEdited = true;
    this.render();
  }

  loadStyle() {
    const style = require("!!css-loader!resolve-url-loader!sass-loader!./style.scss").toString();
    this.appendStyle(style, "AddressInfo");
  }

  loadHtml() {
    return require("html-loader!./index.html");
  }

  after() {
    this.addressForm = new AddressForm({
      parent: $(".address-form", this.element),
      type: this.type,
      className: this.className,
      countryList: this.countryList,
      onDialCode: this.onDialCode,
      onChangePhone: this.onChangePhone,
      phoneOptions: this.phoneOptions,
      tabIndex: this.type === Address.TYPE.SHIPPING_INFO ? 0 : 20,
      inputPadding: 101,
    })


    this.checkSave = new CheckBox({
      parent: $(".check-save", this.element),
      className: "check-save-cb" + (LocalStorage.isLoggedIn() ? "" : " required-login"),
      labelI18n: "checkout_saveToAddressBook",
      checked: false,
      tabIndex: 19,
      onChange: (val) => {
        typeof this.onCheckSave === "function" && this.onCheckSave(this.type, val);
      },
    })

    this.addEvent();
  }

  addEvent() {
    $(".group-save-address .btn-save-address", this.element).on("click", (e) => {
      if (this.validateForm(true)) {
        typeof this.onSaveAddress === "function" && this.onSaveAddress(this.type);
      }
    })
  }

  setSaveLoading(isLoading = false) {
    isLoading ? $(".group-save-address .btn-save-address", this.element).addClass("loading") : $(".group-save-address .btn-save-address", this.element).removeClass("loading");
  }

  setActiveField(isRFQOrder = false) {
    this.addressForm.setActiveField(isRFQOrder);
    if (isRFQOrder) {
      $(".group-save-address", this.element).addClass("hide");
      $(".check-save", this.element).addClass("hide");
    } else {
      $(".group-save-address", this.element).removeClass("hide");
      $(".check-save", this.element).removeClass("hide");
    }
  }
  setLogined(isLogined = LocalStorage.isLoggedIn()) {
    if (isLogined) {
      this.checkSave.element.removeClass("required-login");
    } else {
      this.checkSave.element.addClass("required-login");
    }
  }

  setAddressCountry(addressCountry) {
    this.addressForm.setAddressCountry(addressCountry);
  }

  /** @param {Address} address */
  fillData(address = {}) {
    this.addressForm.fillData(address);
    let country = this.addressForm.phone.getCountry();
    if (country) {
      if (this.type === Address.TYPE.SHIPPING_INFO && country !== LocalStorage.getShipping()) {
        LocalStorage.setShipping(country);
      }
      if (this.type === Address.TYPE.BILLING_INFO && country !== LocalStorage.getBilling()) {
        LocalStorage.setBilling(country);
      }
    }
  }

  getLoadingInput() {
    return !this.addressForm || this.addressForm.getLoading() || this.addressForm.getLoadingInput();
  }


  /** @returns {Address}*/
  getDataAddress(isRFQOrder = false, hasId = false) {
    return this.addressForm.getDataAddress(isRFQOrder, hasId);
  }

  getParamsAddress(isRFQOrder = false, hasId = false) {
    return this.addressForm.getParamsAddress(isRFQOrder, hasId);
  }

  getId() {
    return this.addressForm.getId();
  }

  getType() {
    return this.addressForm.getType();
  }

  getPhone() {
    return this.addressForm.phone;
  }

  setPhoneNumber(phone) {
    this.addressForm.phone.setNumber(phone);
  }

  setPhoneCountry(country) {
    this.addressForm.phone.setCountry(country);
  }

  getAddress() {
    return this.addressForm.address;
  }

  getName() {
    return this.addressForm.name;
  }

  getEmail() {
    return this.addressForm.email;
  }

  focusName() {
    this.addressForm.name.focus();
  }
  getCheckSave() {
    return this.checkSave.getValue();
  }

  isSameCountry(phoneNumber, currentShipping) {
    return this.addressForm.isSameCountry(phoneNumber, currentShipping);
  }

  getDialCode(phoneNumber) {
    return this.addressForm.getDialCode(phoneNumber);
  }


  validateForm = (isShowValid = true, isRFQ = false) => {
    return this.addressForm.validateForm(isShowValid, isRFQ);
  }

  resetAddress(isOnlyAddress = false) {
    this.addressForm.resetAddress(isOnlyAddress);
  }

  setIsEdit(isEdited = true) {
    this.addressForm.setIsEdit(isEdited);
  }
  getIsEdited() {
    return this.addressForm.getIsEdited();
  }
}